export default function SkipBackIcon() {
  return (
    <svg
      fill="none"
      height="21"
      viewBox="0 0 16 21"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.99 4V1.21c0-.45-.54-.67-.85-.35L3.35 4.65c-.2.2-.2.51 0 .71l3.79 3.79a.5.5 0 0 0 .85-.35V6c3.73 0 6.68 3.42 5.86 7.29-.47 2.27-2.31 4.1-4.57 4.57-3.57.75-6.75-1.7-7.23-5.01a.984.984 0 0 0-.98-.85c-.6 0-1.08.53-1 1.13.62 4.39 4.8 7.64 9.53 6.72 3.12-.61 5.63-3.12 6.24-6.24C16.83 8.48 12.94 4 7.99 4z" />
      <path d="M6.89 15h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V15zM8.65 10.74l-.25 2.17.67.16c.03-.03.06-.07.1-.09.02-.01.04-.023.06-.035a.664.664 0 0 1 .21-.085c.05-.01.12-.02.2-.02.11 0 .22.02.3.05.08.03.15.08.21.15.06.07.1.14.13.24.03.1.04.2.04.31 0 .11 0 .21-.03.31s-.07.18-.11.25a.487.487 0 0 1-.45.23.65.65 0 0 1-.42-.15c-.11-.09-.17-.23-.19-.41h-.84c0 .2.05.38.13.53.08.15.18.29.32.39.14.1.29.19.46.24.17.05.35.08.53.08.25 0 .46-.05.64-.12.18-.07.33-.18.45-.31s.21-.28.27-.45c.06-.17.09-.35.09-.54 0-.22-.04-.42-.09-.6-.05-.18-.14-.33-.25-.45-.11-.12-.25-.21-.41-.28a1.349 1.349 0 0 0-.75-.08c-.06.01-.12.03-.18.04-.06.01-.11.03-.15.05a.586.586 0 0 1-.049.021c-.022.01-.043.017-.06.029l.11-.92h1.7v-.71H8.65z" />
    </svg>
  );
}
